// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 423) return "js/bundle/423.2b4279e0ac09a0f6dba8.js";
	if (chunkId === 976) return "js/bundle/976.3865867cef40d6aab97f.js";
	// return url for filenames based on template
	return undefined;
};